/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';
import loadsStore from '../../../stores/loads-store';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'

class EditableAltitude extends Component {

  constructor(props) {
    super(props);
    this.setEditable = this.setEditable.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      editMode: false,
      load: props.load,
      altitudes: []
    };
  }

  setEditable() {
    this.setState({
      editMode: !this.state.editMode
    });
  }



  handleSubmit(loadNum, jumpId, jumperId) {
    this.setEditable();
    // console.log(loadNum + " jumpId: " + jumpId + " jumperId: " + jumperId);
    loadsStore.removeJumper(loadNum, jumpId, jumperId);
  }
  wantsEidtable = (data) => {
    this.setState({
      editMode: data,
      isModalOpen: false
    })
  }
  changeJumper = (isCompleted) => {
    if (isCompleted) {
      // this.props.openModel({ isModal: true, editType: false })
      this.setState({
        isModalOpen: true
      })
    }
    else {
      this.setState({
        editMode: !this.state.editMode
      })
    }
  }

  
  componentDidMount() {
	var altitudes = loadsStore.getAltitudes();
	this.setState({altitudes: altitudes});
    document.addEventListener('click', this.handleClickOutside, true);
  }
  
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }
  
  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      this.setState({
        editMode: false
      });
    }
  }

  setAltitude = (loadNum, jumpId, altitude) => {
  	loadsStore.updateFunJump(loadNum, jumpId, {altitude: altitude});
  }
  render() {
	var altitudeMenu = this.state.altitudes.map(alt => 
		<a className="dropdown-item" onClick={() => { this.setAltitude(this.props.loadNum, this.props.jumpId, alt.name) }} >{alt.name}</a>
	)
	
    return (
      <React.Fragment>
        {
          !this.state.editMode ?
            // <div className="jumpType-button" onClick={()=>this.changeJumper(this.props.isCompleted)} style={{ padding: '0 1 0 4px' }}>
            //   {this.renderJumpSize()} {this.props.jumpType}
            // </div>
            <div className="funjumpType-button" onClick={() => !this.props.isCompleted && this.changeJumper(this.props.isCompleted)} style={{ padding: '0 1 0 4px' }}>
              {this.props.altitude}
            </div>
            :
            <div className="dropdown-menu" onBlur={()=>{this.setState({editMode: true})}}>
              <a className="dropdown-item">Select..</a>
              {altitudeMenu}
            </div>
        }

      </React.Fragment>
    );
  }
}

const mstp = state => {
	return {
		state
	}
}
const mdtp = dispatch => {
	return {
		addCompletedJumpers: (loadId, cjumpId, jumpPostBody) => dispatch(loadsStore.addCompletedJumpers(loadId, cjumpId, jumpPostBody)),
	}
}

//  export default EditableFunJumper;
export default EditableAltitude


